module.exports = __webpack_public_path__ + "img/logo.739ff85d.png";